import admin from '../../en/admin.json';
import common from '../../en/common.json';
import errors from '../../en/errors.json';
import forms from '../../en/forms.json';
import nav from '../../en/nav.json';

export const en = { admin, common, errors, forms, nav } as const;

export default en;
